// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"ImagePlaceholder-module--placeholder--2834W","loaded":"ImagePlaceholder-module--loaded--3Pkfh"};